import { Chip, DatePicker } from "@ui";
import style from "./PayDateCell.module.scss";
import { IProxy } from "@interfaces/admin/proxy";
import cn from "classnames";
import { useUpdateProxyDataMutation } from "@RTKQuery/admin/proxy/proxy";
import { IoClose } from "react-icons/io5";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useEffect } from "react";
import { removeRowError } from "@global-state/pages/admin/myProxies/slice";

export function PayDateCell({ pay_date, proxy_id }: { pay_date: IProxy["pay_date"], proxy_id: IProxy["id"] }) {
    const [updateProxyData, { isSuccess, reset }] = useUpdateProxyDataMutation();

    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling } = useAppSelector(state => state.myProxiesAdminPage);

    const rowsIsError = useAppSelector(state => state.myProxiesAdminPage.rowsIsError)?.[proxy_id] || [];

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isSuccess) {
            dispatch(removeRowError({
                proxyId: proxy_id,
                colName: "pay_date"
            }))
        }
    }, [isSuccess])

    return (
        <div className={style.cell}>
            <DatePicker
                currentDate={(() => {
                    if (pay_date) {
                        const [year, month, day] = pay_date.split("T")[0].split("-")

                        return day + "." + month + "." + year;
                    } else {
                        return ""
                    }
                })()}
                onChangeDate={(newDate) => {
                    const [day, month, year] = newDate.split(".").map(Number);

                    const formatDate = new Date(Date.UTC(year, month - 1, day));

                    updateProxyData({
                        proxy_id,
                        params: {
                            page: activePaginationPage,
                            limit: activePaginationLimit,
                            router_id: activeSearchIdParameter,
                            operator: activeOperator,
                            phone_number: activeSearchPhoneParameter,
                            selling: activeSelling
                        },
                        body: {
                            pay_date: formatDate.toISOString()
                        }
                    })
                }}
            />

            <div className={cn("absolute left-full top-1/2 z-10 pl-[5px] -translate-y-1/2", rowsIsError.includes("pay_date") ? "block" : "hidden")}>
                <Chip
                    text="Помилка"
                    color="red"
                    icon={<IoClose
                        className="w-[15px] text-[#F81F1F] h-[15px] cursor-pointer"
                        onClick={() => {
                            reset();
                            dispatch(removeRowError({
                                proxyId: proxy_id,
                                colName: "pay_date"
                            }))
                        }}
                    />}
                    aligtIcon="right"
                />
            </div>
        </div>
    )
}